import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import Swiper from 'swiper'
import { Pagination } from 'swiper/modules'

gsap.registerPlugin(ScrollTrigger)

function howWeWork() {
    const triggerWork = document.querySelector('[data-name="trigger-work"]')

    if (!triggerWork) return

    const works = document.querySelectorAll('[data-name="work"]')
    const initialRotation = 70
    const colors = ['#1d4938', '#2e416c', '#142930']

    const mm = gsap.matchMedia()

    mm.add('(min-width: 1115px)', () => {
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: triggerWork,
                pin: true,
                start: 'top top',
                pinSpacing: true,
                end: '+=500% top',
                scrub: true,
            },
        })

        gsap.set('#svg-mask', {
            rotation: `${initialRotation}deg`,
        })
        gsap.set(['[data-name="img-1"], [data-name="img-2"]'], {
            autoAlpha: 0,
        })
        gsap.set([works[1], works[2]], {
            autoAlpha: 0,
        })

        works.forEach((work, index) => {
            tl.addLabel('start')

            tl.to(
                '#svg-mask',
                {
                    rotation: `${initialRotation - 90 * index}deg`,
                    duration: 1,
                },
                `+=${0.2 * index}`
            )

            if (index > 0) {
                tl.to(
                    works[index - 1],
                    {
                        autoAlpha: 0,
                        duration: 0.2,
                    },
                    '<'
                ).to(
                    `[data-name="img-${index - 1}"]`,
                    {
                        autoAlpha: 0,
                        duration: 0.2,
                    },
                    `${index === 1 ? '>60%' : '<30%'}`
                )

                tl.to(
                    '#svg-mask',
                    {
                        scale: 0.7,
                    },
                    '<-50%'
                )
            }
            tl.to(
                `[data-name="img-${index}"]`,
                {
                    autoAlpha: 1,
                    duration: 0.2,
                },
                `${index === 2 ? '>-20%' : '<60%'}`
            )

            tl.to(
                work,
                {
                    autoAlpha: 1,
                    duration: 0.2,
                },
                `>`
            ).to(
                '#svg-mask',
                {
                    scale: 1,
                },
                '<-75%'
            )

            tl.to(
                '#svg-mask path',
                {
                    fill: `${colors[index]}`,
                },
                '<0.15'
            ).to(
                '[data-name="fauxBg"]',
                {
                    backgroundColor: `${colors[index]}`,
                },
                '<'
            )
        })
    })

    mm.add('(max-width: 1114px)', () => {
        const sections = document.querySelectorAll(
            '[data-name="swiper-how-we-work"]'
        )

        if (!sections.length) return

        sections.forEach((section) => {
            const slider = section.querySelector('.swiper')
            const images = section.querySelectorAll(
                '[data-name="swiper-how-we-work-image"]'
            )

            images[0].classList.add('opacity-100')
            images[0].classList.remove('opacity-0')

            const swiper = new Swiper(slider, {
                slidesPerView: 1,
                spaceBetween: 40,
                modules: [Pagination],
                pagination: {
                    type: 'fraction',
                    el: '[data-name="swiper-how-we-work-pagination"]',
                },

                on: {
                    slideChange: function () {
                        console.log(swiper.activeIndex)
                        console.log(images[swiper.activeIndex])

                        images[swiper.previousIndex].classList.remove(
                            'opacity-100'
                        )
                        images[swiper.previousIndex].classList.add('opacity-0')
                        images[swiper.activeIndex].classList.remove('opacity-0')
                        images[swiper.activeIndex].classList.add('opacity-100')
                    },
                },
            })
        })
    })
}

export default howWeWork
